import React,{Component} from 'react';
import '../../CSS/style.css';

export default class SlidersItem extends Component{
    render(){
        const width = (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) - 17;
        const height = width / 4;
        let style={
            width:this.props.images.length*width+'px',
            left:this.props.index*-width+'px',
            transitionDuration:this.props.speed+'s',
            zIndex: 2
        };
        return (
            <ul className="sliders" style={style}>
                {
                    this.props.images.map((item,index)=>(
                        <li
                            className="slider"
                            style={{ width: width, height: height }}
                            key={index}
                        >
                            <img src={item} alt="bannerImage" />
                        </li>
                    ))
                }
            </ul>
        )
    }
}